import React, { createContext, useState, useEffect } from 'react';
import WorkspaceServices from '../api/workspaceServices';

export const WorkspaceContext = createContext();

export const WorkspaceProvider = ({ children }) => {
  const [workspaces, setWorkspaces] = useState([]);
  const [loading, setLoading] = useState(true); 
  const [selectedWorkspace, setSelectedWorkspace] = useState(null); 

  useEffect(() => {
    const fetchWorkspaces = async () => {
      try {
        const data = await WorkspaceServices.listWorkspaces();
        setWorkspaces(data);
        const savedWorkspaceId = localStorage.getItem('frac7al-app-workspaceId');
        if (savedWorkspaceId) {
          const savedWorkspace = data.find(ws => ws.id === savedWorkspaceId);
          if (savedWorkspace) setSelectedWorkspace(savedWorkspace);
        }
      } catch (error) {
        console.error('Error al cargar los workspaces:', error);
      } finally {
        setLoading(false); 
      }
    };

    fetchWorkspaces();
  }, []);

  const selectWorkspace = (workspaceId) => {
    const workspace = workspaces.find(ws => ws.id === workspaceId);
    if (workspace) {
      setSelectedWorkspace(workspace);
      localStorage.setItem('frac7al-app-workspaceId', workspaceId); // Guardar en localStorage
    }
  };  

  return (
    <WorkspaceContext.Provider value={{ 
      workspaces, 
      loading, 
      selectedWorkspace, 
      selectWorkspace 
    }}>
      {children}
    </WorkspaceContext.Provider>
  );
};
